import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./AddCategory.css";
import UploadFileIcon from "../../assets/images/upload-file-icon.svg";
import SuccessIcon from "../../assets/images/succes-icon.png";
import SuccessMessageImage from "../../assets/images/success-message.svg";
import PopupMessage from "../../components/Popup/Popup";
import { Link } from "react-router-dom";
import API_BASE_URL from "../../config";
import { ClipLoader } from "react-spinners";

const AddCategory = () => {
  const [name, setName] = useState("");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isImageUploaded, setIsImageUploaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false); 
  const [successMessage, setSuccessMessage] = useState("");
  const [isPageLoading, setIsPageLoading] = useState(true); 
  const navigate = useNavigate();
  const [popupMessage, setPopupMessage] = useState({ text: "", type: "" });
  const [showPopup, setShowPopup] = useState(false);

  const displayPopup = (text, type = "success") => {
        setPopupMessage({ text, type });
        setShowPopup(true);

        setTimeout(() => {
            setShowPopup(false);
        }, 5000);
    };

  useEffect(() => {
    const adminId = sessionStorage.getItem("admin_id");
    if (!adminId) {
      displayPopup("Session expired. Please log in again.", "error");
      sessionStorage.clear();
      navigate("/admin-login");
    }
    setIsPageLoading(false); 
  }, [navigate]);

  const handleFileChange = (e) => {
    if (e.target.files.length === 0) return;
    const file = e.target.files[0];
    setImage(file);
    setImagePreview(URL.createObjectURL(file));
    setIsImageUploaded(true);
    e.target.value = "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const adminId = sessionStorage.getItem("admin_id");
    if (!adminId) {
      displayPopup(
        <>
          Admin session expired. Please <Link to="/admin-login" className="popup-link">log in</Link> again.
        </>,
        "error"
      );
      return;
    }
    if (!name.trim()) {
      displayPopup("Please enter the category name.", "error");
      return;
    }
    if (!image) {
      displayPopup("Please upload image.", "error");
      return;
    }
    setIsLoading(true); 
    const formData = new FormData();
    formData.append("admin_id", adminId);
    formData.append("category_name", name);
    formData.append("category_image", image);
    try {
      const response = await fetch(`${API_BASE_URL}/add-category`, {
        method: "POST",
        body: formData,
        headers: {
          "Accept": "application/json",
        },
      });
      const data = await response.json();
      if (response.ok) {
        displayPopup("Category added successfully!", "success");
        setTimeout(() => {
          navigate("/view-categories", { state: { successMessage: "Category added successfully!" } });
        }, 2000);
      } else {
        displayPopup(data.error || "Failed to add category.", "error");
      }
    } catch (error) {
      console.error("Error:", error);
      displayPopup("Something went wrong. Please try again.", "error");
    } finally {
      setIsLoading(false); 
    }
  };

  const handleCancel = () => {
    navigate("/view-categories");
  };

  if (isPageLoading) {
    return (
      <div className="full-page-loading">
        <div className="loading-content">
          <ClipLoader size={50} color="#4450A2" />
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="add-card-form-page">
      <div className="admin-popup">
          {showPopup && (
                    <PopupMessage
                        message={popupMessage.text}
                        type={popupMessage.type}
                        onClose={() => setShowPopup(false)}
                    />
                )}
      </div>
      <header className="form-header">
        <h1 className="form-title">Category Details</h1>
        {successMessage && (
          <div className="success-message-container">
            <img src={SuccessMessageImage} alt="Success" className="success-image" />
            <p className="success-message-text">{successMessage}</p>
          </div>
        )}
      </header>
      <div className="add-card-form">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name" className="category-name-label">
              Name of the Category
            </label>
            <input
              type="text"
              id="name"
              className="category-name-input"
              placeholder="Enter the Category Name..."
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="form-group upload-file">
            <label htmlFor="image" className="upload-label">
              Upload an Image
            </label>
            <div
              className="upload-box"
              onClick={(e) => {
                e.stopPropagation();
                document.getElementById("image").click();
              }}
            >
              {isImageUploaded ? (
                <div className="success-icon">
                  <img src={SuccessIcon} alt="Success Icon" className="success-icon-img" />
                  <p>Successfully uploaded file</p>
                </div>
              ) : (
                <>
                  <img src={UploadFileIcon} alt="Upload Icon" className="upload-icon" />
                  <p className="upload-text">
                    <span>Upload File</span> or Drag and Drop
                  </p>
                </>
              )}
              <input
                type="file"
                id="image"
                className="upload-input"
                onChange={handleFileChange}
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          </div>
          <div className="form-actions">
            <button type="button" onClick={handleCancel} className="admin-cancel-button">
              Cancel
            </button>
            <button type="submit" className="admin-submit-button" disabled={isLoading}>
              {isLoading ? <ClipLoader size={20} color="#ffffff" /> : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCategory;
